export const linkedAccounts = {
    enabled: true,
    _description: 'Enables the linked accounts feature on bank card settings page.',
};
